import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';
import * as mutationTypes from './mutation-types';

// type cachePathType = ['contribute'];
const state = {
  // 用户所选学校
  chooseSchool: {
    text: '请选择学校',
    value: -1,
  },
  votes: 0,
  activeNum: 0,
};
const mutations = {
  [mutationTypes.SAVE_SCHOOL_DATA](state: any, schooldata: any) {
    state.chooseSchool = schooldata;
    console.log('schooldata', schooldata);
  },
  [mutationTypes.UPDATE_POST_LIKE](state: any) {
    state.votes = Number(state.votes) + 1;
  },
  [mutationTypes.GET_POST_LIKE](state: any, votes: any) {
    state.votes = votes;
  },
  [mutationTypes.RECORD_ACTIVE_NUM](state: any, num: any) {
    state.activeNum = num;
  },
};
const CDWM20200317 = {
  namespaced: true,
  state,
  mutations,
};

export default CDWM20200317;
